import { Close, IconLink } from 'wujieai-react-icon'
import { useAtom } from 'jotai'
import { ISearchResult, searchResultsAtom } from './atom'
import { MyImage } from '~/components/ui/MyImage'
import { formatTime } from '~/utils'
import { useEffect, useRef } from 'react'

export function SearchResult() {
  const [searchResults, setSearchResults] = useAtom(searchResultsAtom)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current?.scrollTop) {
      ref.current.scrollTop = 0
    }
  }, [searchResults])

  return (
    <div className="h-full bg-neutral-200 py-4 px-2 rounded-xl">
      <div className="flex items-center justify-between mb-3">
        <div className="text-base text-neutral-900">搜索结果</div>
        <div
          className="text-neutral-400 leading-none cursor-pointer"
          onClick={() => {
            setSearchResults(null)
          }}
        >
          <Close size={20} />
        </div>
      </div>
      <div
        className="overflow-y-auto scrollbar-hidden py-3 space-y-2"
        style={{
          height: 'calc(100% - 36px)',
        }}
        ref={ref}
      >
        {searchResults?.map((it, index) => {
          return <SearchItem key={index} result={it} />
        })}
      </div>
    </div>
  )
}

export function SearchItem({ result }: { result: ISearchResult }) {
  return (
    <div
      className="rounded-lg p-2 bg-neutral-200 hover:bg-neutral-300 transition-all space-y-1 cursor-pointer select-none"
      onClick={() => {
        if (!result.url) return
        window.open(result.url, '_blank')
      }}
    >
      <div className="flex items-center gap-1 text-xs">
        {false ? (
          <MyImage
            className="w-4 h-4 rounded-full block"
            src={result.favicon}
          ></MyImage>
        ) : (
          <div className="w-4 h-4 rounded-full bg-neutral-400 text-neutral-500 flex items-center justify-center">
            <IconLink size={12} />
          </div>
        )}
        <div className="text-neutral-900">{result.site}</div>
        {!!result.date && (
          <div className="text-neutral-500">
            {formatTime(result.date, 'YYYY/MM/DD')}
          </div>
        )}
      </div>

      <div className="text-neutral-900 text-sm break-all break-words line-clamp-2 overflow-hidden text-ellipsis">
        {result.title} - {result.url}
      </div>
      <div className="text-neutral-500 text-xs line-clamp-2 overflow-hidden text-ellipsis">
        {result.snippet}
      </div>
    </div>
  )
}
